import { render, staticRenderFns } from "./CurrentPosition.vue?vue&type=template&id=ff0d3650"
import script from "./CurrentPosition.vue?vue&type=script&lang=js"
export * from "./CurrentPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports